/** @format */
import * as yup from "yup";

const passwordRules = /\S/g

export const loginSchema = yup.object().shape({
  email: yup.string().email("Please enter email").required("Email is required"),
  password: yup
    .string()
    .min(4, "Password must be at least 4 characters")
    .matches(passwordRules, "Password must not contain Whitespaces.")
    .required("Password is required"),
});
